<template>
  <el-dialog :title="$t('editApp.title')" :visible.sync="dialogVisible" width="50%" @close="resetForm">
    <el-form ref="editAppForm" :model="editAppInfo" :rules="rules" label-width="120px">
      <el-form-item :label="$t('editApp.appName')" prop="name">
        <el-input v-model="editAppInfo.name" :placeholder="$t('editApp.appNamePlaceholder')" />
      </el-form-item>
      <el-form-item :label="$t('editApp.securityCode')" prop="securityCode">
        <el-input v-model="editAppInfo.securityCode" :placeholder="$t('editApp.securityCodePlaceholder')" />
      </el-form-item>
      <el-form-item :label="$t('editApp.whiteList')" prop="whileListIp">
        <el-input v-model="editAppInfo.whileListIp" :placeholder="$t('editApp.whiteListPlaceholder')" />
      </el-form-item>
      <el-form-item :label="$t('editApp.blackList')" prop="blackListIp">
        <el-input v-model="editAppInfo.blackListIp" :placeholder="$t('editApp.blackListPlaceholder')" />
      </el-form-item>
      <el-form-item :label="$t('editApp.remark')" prop="remark">
        <el-input type="textarea" v-model="editAppInfo.remark" :placeholder="$t('editApp.remarkPlaceholder')" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button type="primary" @click="editApp">
        {{ $t('common.save') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateApp } from '@/api/dev/appApi'

export default {
  name: 'EditApp',
  data() {
    return {
      dialogVisible: false,
      editAppInfo: {
        appId: '',
        name: '',
        securityCode: '',
        whileListIp: '',
        blackListIp: '',
        remark: ''
      },
      rules: {
        name: [
          { required: true, message: this.$t('editApp.appNameRequired'), trigger: 'blur' },
          { min: 2, max: 50, message: this.$t('editApp.appNameLength'), trigger: 'blur' }
        ],
        securityCode: [
          { max: 64, message: this.$t('editApp.securityCodeLength'), trigger: 'blur' }
        ],
        whileListIp: [
          { max: 200, message: this.$t('editApp.whiteListLength'), trigger: 'blur' }
        ],
        blackListIp: [
          { max: 200, message: this.$t('editApp.blackListLength'), trigger: 'blur' }
        ],
        remark: [
          { max: 200, message: this.$t('editApp.remarkLength'), trigger: 'blur' }
        ],
        appId: [
          { required: true, message: this.$t('editApp.appIdRequired'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(app) {
      this.editAppInfo = { ...app }
      this.dialogVisible = true
    },
    resetForm() {
      this.$refs.editAppForm.resetFields()
    },
    async editApp() {
      try {
        await this.$refs.editAppForm.validate()
        await updateApp(this.editAppInfo)
        this.$message.success(this.$t('editApp.saveSuccess'))
        this.dialogVisible = false
        this.$emit('success')
      } catch (error) {
        console.error('修改应用失败:', error)
      }
    }
  }
}
</script>